var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-datetime-picker',{attrs:{"label":_vm.labelText,"time-format":"HH:mm","date-format":"dd.MM.yyyy","text-field-props":{
      outlined: _vm.cs.inputOutlined,
      filled: _vm.cs.inputFilled,
      dense: _vm.cs.inputDense,
      rounded: _vm.cs.inputRounded,
      backgroundColor: _vm.backgroundColor,
      hideDetails: true,
      class: 'mb-2',
      disabled: !_vm.field.canEdit
    }},model:{value:(_vm.datetime),callback:function ($$v) {_vm.datetime=$$v},expression:"datetime"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }